import React from 'react';

const CastingRequirements = () => {
  const requirements = [
    {
      level: 'Principal & Soloist',
      details: [
        'Extensive professional performance experience with a reputable company.',
        'Exceptional classical and contemporary technique.',
        'Strong partnering skills and stage presence.',
        'Ability to take on leading and featured roles in a diverse repertoire.',
        'Auditions by invitation only. Please submit a CV, headshot, and performance reel to casting@northwestballet.com.'
      ]
    },
    {
      level: 'Corps de Ballet',
      details: [
        'Advanced training in classical ballet.',
        'Professional or advanced pre-professional experience.',
        'Excellent musicality and ability to learn choreography quickly.',
        'Strong ensemble skills and a dedicated work ethic.',
        'Open auditions are held annually in the spring. Check our News page for announcements.'
      ]
    },
    {
      level: 'Apprentice & Trainee Program',
      details: [
        'High level of classical ballet training (ages 17-22).',
        'Demonstrated potential for a professional career.',
        'Desire to learn and grow in a professional company environment.',
        'This program serves as a bridge between student and professional life, offering performance opportunities and mentorship.',
        'Admission is through our annual summer intensive program or by video application.'
      ]
    }
  ];

  return (
    <div className="container-custom py-12">
      <h1 className="text-4xl font-bold font-elegant text-ballet-burgundy mb-4 text-center">Company Casting Requirements</h1>
      <p className="text-lg text-gray-700 mb-12 text-center max-w-3xl mx-auto">
        Northwest Ballet Theater seeks talented, dedicated dancers to join our company. We are a professional company performing a mix of classical and contemporary works. All positions are paid, competitive contracts for a 35-week season.
      </p>
      <div className="space-y-8">
        {requirements.map((req, index) => (
          <div key={index} className="bg-white rounded-lg shadow-elegant p-8">
            <h3 className="text-3xl font-elegant text-ballet-burgundy font-semibold mb-4">{req.level}</h3>
            <ul className="list-disc list-inside space-y-2 text-gray-700">
              {req.details.map((detail, i) => (
                <li key={i}>{detail}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="mt-12 text-center bg-ballet-light-pink p-6 rounded-lg">
        <h4 className="text-2xl font-elegant font-semibold text-ballet-burgundy mb-2">Video Submissions</h4>
        <p className="text-gray-700">
          For all video submissions, please include a short classical variation, a contemporary solo, and partnering work if available. Links should be sent to <a href="mailto:casting@northwestballet.com" className="text-ballet-burgundy font-bold hover:underline">casting@northwestballet.com</a>.
        </p>
      </div>
    </div>
  );
};

export default CastingRequirements;
